import { render } from "./EquipamentView.vue?vue&type=template&id=60c323a1&scoped=true"
import script from "./EquipamentView.vue?vue&type=script&lang=js"
export * from "./EquipamentView.vue?vue&type=script&lang=js"

import "./EquipamentView.vue?vue&type=style&index=0&id=60c323a1&lang=scss&scoped=true"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/eventos-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c323a1"]])

export default __exports__